import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useRolle } from '../auth/useRolle';
import { GuennieIcon } from './GuennieIcon';
import { SpaghettiDivider } from './SpaghettiDivider';

/** Drei-Striche-Icon fürs Burger-Menü (siehe theme.css, Klasse `.menu-knopf`). */
function BurgerIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2 5h16M2 10h16M2 15h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

const linkStil = ({ isActive }: { isActive: boolean }) => ({
  padding: '0.4rem 0.7rem',
  borderRadius: 999,
  textDecoration: 'none',
  color: isActive ? '#fff' : 'var(--espresso)',
  background: isActive ? 'var(--erdbeere)' : 'transparent',
  fontWeight: 600,
  fontSize: '0.95rem',
});

export function Layout() {
  const { darfTesten, istVerwalter, anzeigename } = useRolle();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOffen, setMenuOffen] = useState(false);

  // Menü nach jedem Seitenwechsel schließen — sonst bliebe die aufgeklappte
  // Liste nach einem Tap auf einen Menüpunkt einfach stehen.
  useEffect(() => setMenuOffen(false), [location.pathname]);

  async function abmelden() {
    await signOut();
    navigate('/');
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header
        style={{
          background: 'var(--sahne)',
          borderBottom: '1px solid var(--raspel)',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            maxWidth: 'var(--content-max)',
            margin: '0 auto',
            padding: '0.7rem 1.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            position: 'relative',
          }}
        >
          <NavLink
            to="/app"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              textDecoration: 'none',
              color: 'var(--espresso)',
            }}
          >
            <GuennieIcon gefuellt groesse={30} farbe="var(--erdbeere)" />
            <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.15rem' }}>GünniEis</strong>
          </NavLink>

          <button
            className="btn btn-sekundaer menu-knopf"
            onClick={() => setMenuOffen((o) => !o)}
            aria-expanded={menuOffen}
            aria-label={menuOffen ? 'Menü schließen' : 'Menü öffnen'}
            style={{ padding: '0.5rem 0.7rem' }}
          >
            <BurgerIcon />
          </button>

          <nav className={`hauptnav${menuOffen ? ' offen' : ''}`}>
            <NavLink to="/app" end style={linkStil}>
              Übersicht
            </NavLink>
            <NavLink to="/app/karte" style={linkStil}>
              Karte
            </NavLink>
            <NavLink to="/app/eisdielen" style={linkStil}>
              Eisdielen
            </NavLink>
            <NavLink to="/app/verkostungen" style={linkStil}>
              Verkostungen
            </NavLink>
            <NavLink to="/app/bestenlisten" style={linkStil}>
              Bestenlisten
            </NavLink>
            {darfTesten ? (
              <NavLink to="/app/neue-verkostung" style={linkStil}>
                Neue Verkostung
              </NavLink>
            ) : null}
            {darfTesten ? (
              <NavLink to="/app/meine-verkostungen" style={linkStil}>
                Meine
              </NavLink>
            ) : null}
            {istVerwalter ? (
              <NavLink to="/app/verwaltung" style={linkStil}>
                Verwaltung
              </NavLink>
            ) : null}
            <span className="nutzerzeile">
              <span style={{ color: 'var(--espresso-70)', fontSize: '0.85rem' }}>{anzeigename}</span>
              <button className="btn btn-sekundaer" onClick={abmelden}>
                Abmelden
              </button>
            </span>
          </nav>
        </div>
        <SpaghettiDivider hoehe={10} />
      </header>

      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      <footer
        style={{
          borderTop: '1px solid var(--raspel)',
          padding: '1.5rem',
          textAlign: 'center',
          fontSize: '0.85rem',
          color: 'var(--espresso-70)',
        }}
      >
        <SpaghettiDivider hoehe={14} />
        <p>
          GünniEis – Verkostungsführer für Spaghetti-Eis ·{' '}
          <a href="/impressum">Impressum</a> · <a href="/datenschutz">Datenschutz</a>
        </p>
      </footer>
    </div>
  );
}
